import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

export function useViewTemplateWithUITemplate(
  workflowTemplateId?: string | null,
  viewTemplateId?: string | null,
): {
  viewTemplate?: API.GetViewTemplateQueryWithUITemplateQuery['getViewTemplate'];
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    API.GetViewTemplateQueryWithUITemplateQuery,
    API.GetViewTemplateQueryWithUITemplateQueryVariables
  >(Queries.viewTemplate.getViewTemplateWithUITemplate, {
    variables: {
      input: { workflowTemplateId: workflowTemplateId ?? '', id: viewTemplateId ?? '' },
    },
    skip: isNil(workflowTemplateId) || isNil(viewTemplateId),
  });

  return {
    viewTemplate: data?.getViewTemplate,
    loading,
    error,
  };
}
